/* ============================================================================
   LO NUESTRO — comportamiento
   Un solo momento autoral: el rasgado por la perforación.
   Todo lo demás arranca desde estados ya visibles.
   ========================================================================= */

(() => {
  'use strict';

  const quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* --- Fecha de corte -----------------------------------------------------
     Es una fecha REAL de cierre de producción, no un reloj que se reinicia.
     Cámbiala en un solo sitio: data-corte en <body>.                       */

  /* Packs: 1.ª pieza entera; con dos, la 2.ª al −30 %; con tres, 2.ª y 3.ª al −35 %.
     Redondeo por pieza, igual que Shopify al aplicar el descuento. */
  const PACK = { 1: [1], 2: [1, 0.70], 3: [1, 0.65, 0.65] };
  const precioPack = (u, n) => (PACK[n] || PACK[1]).reduce((t, f) => t + Math.round(u * 100 * f) / 100, 0);

  const CORTE = new Date(document.body.dataset.corte || '2026-11-17T23:59:59+01:00');

  /* --- 1. El rasgado ------------------------------------------------------ */

  function rasgado() {
    const pieza = $('[data-rasga]');
    const talon = $('[data-talon]');
    if (!pieza || !talon) return;

    if (quieto) { talon.dataset.visible = 'true'; return; }

    let tic = false;
    const pintar = () => {
      tic = false;
      const caja = pieza.getBoundingClientRect();
      // 0 mientras la entrada está entera en pantalla; 1 cuando ya ha subido medio alto.
      // Arranca en 0 al cargar: la entrada se rasga al bajar, no antes.
      const av = Math.min(1, Math.max(0, (60 - caja.top) / (caja.height * 0.55)));

      const cuerpo = $('[data-rasga-cuerpo]', pieza);
      const trozo  = $('[data-rasga-talon]', pieza);
      if (cuerpo && trozo) {
        trozo.style.transform = `translate3d(${av * 13}px, ${av * 42}px, 0) rotate(${av * 3.1}deg)`;
        trozo.style.opacity   = String(1 - av * 0.72);
        cuerpo.style.transform = `rotate(${av * -0.7}deg)`;
      }
      talon.dataset.visible = av > 0.45 ? 'true' : 'false';
    };

    addEventListener('scroll', () => { if (!tic) { tic = true; requestAnimationFrame(pintar); } }, { passive: true });
    addEventListener('resize', pintar, { passive: true });
    pintar();
  }

  /* --- 2. Entradas al viewport -------------------------------------------- */

  function alzas() {
    const objetivos = $$('.alza');
    if (!objetivos.length) return;
    // En el editor de Shopify todo a la vista: ahí se edita, no se pasea
    const editor = !!(window.Shopify && window.Shopify.designMode);
    if (quieto || editor || !('IntersectionObserver' in window)) {
      objetivos.forEach(e => (e.dataset.dentro = 'true'));
      return;
    }
    const ob = new IntersectionObserver((entradas) => {
      entradas.forEach(e => {
        if (!e.isIntersecting) return;
        const r = Number(e.target.dataset.retardo || 0);
        setTimeout(() => (e.target.dataset.dentro = 'true'), r);
        ob.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    objetivos.forEach(e => ob.observe(e));
  }

  /* --- 3. La cuenta hacia el corte ---------------------------------------- */

  function cuenta() {
    const nodos = $$('[data-cuenta]');
    if (!nodos.length) return;

    const pintar = () => {
      const falta = CORTE - Date.now();
      if (falta <= 0) {
        nodos.forEach(n => (n.innerHTML = '<b>Christmas production is closed.</b> Orders placed now go into the next batch.'));
        return;
      }
      const d = Math.floor(falta / 864e5);
      const h = Math.floor(falta / 36e5) % 24;
      const m = Math.floor(falta / 6e4) % 60;
      const s = Math.floor(falta / 1e3) % 60;
      const txt = d > 0
        ? `<b>${d}</b> d <b>${String(h).padStart(2, '0')}</b> h <b>${String(m).padStart(2, '0')}</b> min`
        : `<b>${String(h).padStart(2, '0')}</b>:<b>${String(m).padStart(2, '0')}</b>:<b>${String(s).padStart(2, '0')}</b>`;
      nodos.forEach(n => (n.innerHTML = txt));
    };
    pintar();
    setInterval(pintar, 1000);
  }

  /* --- 4. Fecha de corte en texto ----------------------------------------- */

  function fechas() {
    const f = CORTE.toLocaleDateString('en-GB', { day: 'numeric', month: 'long' });
    $$('[data-fecha-corte]').forEach(n => (n.textContent = f));
    const corto = CORTE.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' }).replace('.', '').toUpperCase();
    $$('[data-fecha-corta]').forEach(n => (n.textContent = corto));
  }

  /* --- 5. Galería ---------------------------------------------------------- */

  function galeria() {
    const g = $('[data-galeria]');
    if (!g) return;
    const grande = $('[data-galeria-grande]', g);
    const pie = $('[data-galeria-pie]', g);
    const miniaturas = $$('[data-mini]', g);

    // Mostrar una foto concreta. Es la única vía: así la foto grande, su pie y
    // la miniatura marcada no pueden desincronizarse nunca.
    const mostrar = (foto) => {
      const m = miniaturas.find(x => x.dataset.mini === foto) || miniaturas[0];
      if (!m) return;
      grande.src = m.dataset.mini;
      grande.alt = m.dataset.alt || '';
      if (pie) pie.textContent = m.dataset.pie || '';
      miniaturas.forEach(x => x.setAttribute('aria-current', String(x === m)));
    };

    miniaturas.forEach((m, i) => {
      m.addEventListener('click', () => mostrar(m.dataset.mini));
      m.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') miniaturas[(i + 1) % miniaturas.length].focus();
        if (e.key === 'ArrowLeft')  miniaturas[(i - 1 + miniaturas.length) % miniaturas.length].focus();
      });
    });

    // Elegir una opción cambia la foto: si pides la redonda, ves la redonda.
    $$('input[type="radio"][data-foto]').forEach(r => {
      r.addEventListener('change', () => { if (r.checked) mostrar(r.dataset.foto); });
    });

    mostrar(miniaturas[0] && miniaturas[0].dataset.mini);
  }

  /* --- 5b. Qué te llega ----------------------------------------------------
     El resumen en castellano llano de lo elegido, justo antes de pagar.
     Es el último sitio donde se puede deshacer una confusión.              */

  function resumen() {
    const caja = $('[data-resumen]');
    if (!caja) return;
    const forma = $('[data-compra]');
    if (!forma) return;

    const pintar = () => {
      const partes = [];
      // lo fijo del producto, que nunca cambia
      $$('[data-resumen-fijo]', caja).forEach(f => partes.push(f.dataset.resumenFijo));
      // lo que depende de lo elegido
      $$('input[type="radio"]:checked', forma).forEach(i => {
        if (i.dataset.resumenTexto) partes.push(i.dataset.resumenTexto);
      });
      const pack = $('input[name="pack"]', forma);
      if (pack && pack.checked) partes.push('<strong>two pieces</strong> (the second 30% off)');

      const lista = $('[data-resumen-lista]', caja);
      if (lista) lista.innerHTML = partes.map(p => '<li>' + p + '</li>').join('');
    };

    forma.addEventListener('change', pintar);
    pintar();
  }

  /* --- 6. El personalizador ----------------------------------------------- */
  /* Un control reescribe la pieza en TODA la página a la vez, en continuo.
     Nada de ventana modal: el grabado se ve donde va a ir.                  */

  function personalizador() {
    const zona = $('[data-grabado]');
    if (!zona) return;

    const todos = $$('[data-graba]', zona);
    // Los campos marcados como opcionales se pintan y se cuentan, pero no bloquean la compra
    const campos = todos.filter(c => !c.hasAttribute('data-opcional'));
    const anadir = $('[data-anadir]');
    const estado = $('[data-estado-grabado]');
    const estaciones = $$('[data-estacion]');

    // Un corazón (o un anillo) por letra. El grabado real solo admite A-Z.
    const pintarLetras = (destino, letras) => {
      destino.textContent = '';
      [...letras].forEach(l => {
        const pieza = document.createElement('span');
        pieza.className = 'joya__pieza';
        pieza.textContent = l;
        destino.appendChild(pieza);
      });
      const vacio = destino.closest('.joya')?.querySelector('[data-joya-vacio]');
      if (vacio) vacio.hidden = letras.length > 0;
    };

    // Una foto cuenta por su archivo, no por su texto
    const valorDe = (c) => c.type === 'file'
      ? (c.files && c.files[0] ? c.files[0].name : '')
      : c.value.trim();

    const pintar = () => {
      let completos = 0;
      todos.forEach(c => {
        const destino = $$(`[data-espejo="${c.dataset.graba}"]`);

        // Los campos de iniciales se limpian mientras se escriben
        if (c.hasAttribute('data-letras')) {
          const limpio = c.value.toUpperCase().replace(/[^A-Z]/g, '');
          if (limpio !== c.value) {
            const pos = c.selectionStart;
            c.value = limpio;
            try { c.setSelectionRange(pos - 1, pos - 1); } catch (e) { /* input sin selección */ }
          }
        }

        const v = valorDe(c);
        if (v && !c.hasAttribute('data-opcional')) completos++;

        destino.forEach(d => {
          if (d.hasAttribute('data-letras-salida')) pintarLetras(d, v);
          else d.textContent = v || d.dataset.vacio || '';
          d.dataset.lleno = v ? 'true' : 'false';
        });

        const cont = c.parentElement.querySelector('[data-cuentaletras]');
        if (cont && c.maxLength > 0) cont.textContent = `${v.length}/${c.maxLength}`;
      });

      const listo = completos === campos.length;

      estaciones.forEach((e, i) => {
        e.dataset.hecha = String(i === 0 ? completos > 0 : i === 1 ? listo : false);
      });

      if (anadir) {
        const bloqueado = !listo || anadir.hasAttribute('data-agotado');
        anadir.toggleAttribute('disabled', bloqueado);
        anadir.setAttribute('aria-disabled', String(bloqueado));
      }
      if (estado) {
        estado.textContent = listo
          ? 'All set. Read it twice before you continue.'
          : `${campos.length - completos} of ${campos.length} details still missing.`;
        estado.dataset.listo = String(listo);
      }
    };

    todos.forEach(c => { c.addEventListener('input', pintar); c.addEventListener('change', pintar); });
    pintar();
  }

  /* --- 6b. La foto, de verdad ----------------------------------------------
     Se elige un archivo y se ve AHÍ MISMO dentro de la maqueta. La foto no
     sale del navegador: esto es solo la previsualización.                  */

  function subidaFoto() {
    const campo = $('[data-foto-archivo]');
    if (!campo) return;

    const vistas = $$('[data-foto-vista]');
    const nombre = $('[data-foto-nombre]');
    const quitar = $('[data-foto-quitar]');
    let url = null;

    // la caja: con foto, miniatura(s) y «Photo added»; sin foto, el texto de siempre
    const caja = campo.closest('.soltar');
    const titulo = caja && $('.soltar__titulo', caja);
    const sub = caja && $('.soltar__sub', caja);
    const textoTitulo = titulo ? titulo.textContent : '';
    const textoSub = sub ? sub.textContent : '';
    let minis = caja && $('.soltar__minis', caja);
    if (caja && !minis) {
      minis = document.createElement('span');
      minis.className = 'soltar__minis';
      minis.setAttribute('aria-hidden', 'true');
      caja.insertBefore(minis, caja.firstChild);
    }
    let urls = [];

    const poner = (archivos) => {
      urls.forEach(u => URL.revokeObjectURL(u));
      urls = (archivos || []).slice(0, 5).map(a => URL.createObjectURL(a));
      const hay = urls.length > 0;
      url = urls[0] || null;

      vistas.forEach(v => {
        v.style.backgroundImage = hay ? `url("${url}")` : '';
        v.dataset.lleno = String(hay);
      });
      if (minis) minis.innerHTML = urls.map(u => '<img src="' + u + '" alt="">').join('');
      if (titulo) titulo.textContent = !hay ? textoTitulo : (urls.length > 1 ? urls.length + ' photos added' : 'Photo added');
      if (sub) sub.textContent = hay ? 'Tap the box to change it' : textoSub;
      if (nombre) nombre.textContent = '';
      if (quitar) quitar.hidden = !hay;
      campo.closest('.campo').dataset.lleno = String(hay);
    };

    campo.addEventListener('change', () => {
      const lista = Array.from(campo.files || []).filter(a => /^image\//.test(a.type));
      if (!lista.length) { campo.value = ''; return poner(null); }
      poner(lista);
    });

    if (quitar) quitar.addEventListener('click', () => {
      campo.value = '';
      poner(null);
      campo.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  /* --- 6c. La maqueta toma la forma elegida -------------------------------- */

  function formaMaqueta() {
    const maqueta = $('[data-maqueta]');
    if (!maqueta) return;
    const opciones = $$('input[name="forma"]');
    if (!opciones.length) return;

    const pintar = () => {
      const sel = opciones.find(o => o.checked);
      if (sel) maqueta.dataset.forma = sel.value;
    };
    opciones.forEach(o => o.addEventListener('change', pintar));
    pintar();
  }

  /* --- 7. Variantes y precio ---------------------------------------------- */

  /* En Shopify la ficha trae el producto en JSON: el precio sale de la variante
     que casa con las opciones elegidas, y esa variante es la que va al carrito. */
  const datosProducto = () => {
    const nodo = $('[data-ma-producto]');
    if (!nodo) return null;
    try { return JSON.parse(nodo.textContent); } catch (e) { return null; }
  };

  function varianteElegida(forma, producto) {
    const elegidas = [];
    $$('input[data-ma-opcion]:checked', forma).forEach(i => (elegidas[Number(i.dataset.maOpcion) - 1] = i.value));
    return producto.variants.find(v => v.options.every((o, k) => elegidas[k] === undefined || elegidas[k] === o)) || null;
  }

  function variantes() {
    const forma = $('[data-compra]');
    if (!forma) return;

    const producto = datosProducto();
    const idVariante = $('[data-ma-variante]', forma);
    const anadir = $('[data-anadir]');

    const eur = n => n.toLocaleString('en-IE', { style: 'currency', currency: 'EUR' });

    const pintar = () => {
      let base  = Number(forma.dataset.pvp      || 0);
      let antes = Number(forma.dataset.pvpAntes || 0);
      let extra = 0;
      let mult = 1;

      if (producto) {
        const v = varianteElegida(forma, producto);
        if (v) {
          base = v.price / 100;
          antes = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price / 100 : 0;
          forma.dataset.pvp = String(base);
          forma.dataset.pvpAntes = String(antes);
          if (idVariante) idVariante.value = v.id;
          if (anadir) anadir.toggleAttribute('data-agotado', !v.available);
        }
      }

      $$('input[type="radio"]:checked, select', forma).forEach(i => {
        if (!producto) extra += Number(i.dataset.extra || (i.selectedOptions?.[0]?.dataset.extra) || 0);
        mult  *= Number(i.dataset.mult  || (i.selectedOptions?.[0]?.dataset.mult)  || 1);
      });
      // Packs: la primera pieza entera y las demás a mitad, redondeadas pieza a pieza como en el pago
      const piezas = Number(($('input[name="quantity"]:checked, input[name="cantidad"]:checked', forma) || {}).value || 1);
      const unidad = base + extra;
      const total = mult === 1 ? unidad : precioPack(unidad, piezas);
      const totalAntes = (antes + extra) * mult;
      $$('[data-precio]').forEach(e => (e.textContent = eur(total)));
      $$('[data-antes]').forEach(e => { if (antes) e.textContent = eur(totalAntes); });
      $$('[data-ahorro]').forEach(e => { if (antes) e.textContent = eur(totalAntes - total); });
      document.dispatchEvent(new CustomEvent('ma:precio'));
    };

    forma.addEventListener('change', pintar);
    pintar();
  }

  /* --- 8. Barra de compra pegada en producto ------------------------------ */

  function talonProducto() {
    const talon = $('[data-talon-producto]');
    const ancla = $('[data-fin-compra]');
    if (!talon || !ancla) return;
    const ob = new IntersectionObserver(([e]) => {
      talon.dataset.visible = e.isIntersecting || e.boundingClientRect.top > 0 ? 'false' : 'true';
    }, { threshold: 0 });
    ob.observe(ancla);
  }

  /* --- 9. Carrito mínimo (demostración local) ----------------------------- */

  function pintarBolsa(n) {
    $$('[data-bolsa]').forEach(e => {
      e.textContent = String(n);
      e.dataset.lleno = n > 0 ? 'true' : 'false';
    });
  }

  function avisar(texto) {
    const aviso = $('[data-aviso-bolsa]');
    if (!aviso) return;
    const t = $('[data-aviso-texto]', aviso);
    if (t && texto) t.textContent = texto;
    aviso.hidden = false;
    clearTimeout(aviso._t);
    aviso._t = setTimeout(() => (aviso.hidden = true), 5200);
  }

  function carritoShopify(forma) {
    const anadir = $('[data-anadir]');
    const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    const enviar = async (ev) => {
      ev.preventDefault();
      if (!anadir || anadir.hasAttribute('disabled')) return;

      const fd = new FormData();
      fd.append('id', $('[data-ma-variante]', forma).value);
      const cantidad = $('input[name="quantity"]:checked', forma);
      fd.append('quantity', cantidad ? cantidad.value : '1');
      $$('[data-propiedad]', forma).forEach(c => {
        const nombre = c.dataset.propiedad || c.dataset.graba;
        if (c.type === 'file') {
          const archivos = Array.from(c.files || []);
          archivos.forEach((a, i) => fd.append(`properties[${archivos.length > 1 ? nombre + ' ' + (i + 1) : nombre}]`, a));
        } else if (c.value.trim()) {
          fd.append(`properties[${nombre}]`, c.value.trim());
        }
      });

      const textoBoton = anadir.textContent;
      anadir.setAttribute('disabled', '');
      anadir.textContent = 'Adding…';
      try {
        const r = await fetch(raiz + 'cart/add.js', {
          method: 'POST', body: fd,
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        });
        const datos = await r.json();
        if (!r.ok) throw new Error(datos.description || datos.message || 'We could not add it.');
        const c = await (await fetch(raiz + 'cart.js', { headers: { 'Accept': 'application/json' } })).json();
        pintarBolsa(c.item_count);
        if (window.maCajon) window.maCajon.abrir(c); else avisar('Added to your bag.');
      } catch (e) {
        avisar(e.message || 'We could not add it. Try again.');
      } finally {
        anadir.textContent = textoBoton;
        anadir.removeAttribute('disabled');
      }
    };

    forma.addEventListener('submit', enviar);
  }

  /* --- 9b. La bolsa lateral (solo en Shopify) ------------------------------
     Se abre al añadir una pieza y al tocar la bolsa de la cabecera. Enseña lo
     que se va a grabar en cada línea, deja cambiar cantidades y sugiere otra
     pieza. Sin JS, la bolsa de la cabecera sigue llevando a /cart. */

  function cajon() {
    const caja = $('[data-cajon]');
    if (!caja || !(window.Shopify && window.Shopify.shop)) return;
    const cuerpo = $('[data-cajon-cuerpo]', caja);
    const pie = $('[data-cajon-pie]', caja);
    const raiz = (window.Shopify.routes && window.Shopify.routes.root) || '/';
    const leer = sel => { try { return JSON.parse(($(sel) || {}).textContent || 'null'); } catch (e) { return null; } };
    const piezas = leer('[data-cajon-piezas]') || [];
    const textos = leer('[data-cajon-textos]') || {};
    const eur = c => (c / 100).toLocaleString('en-IE', { style: 'currency', currency: 'EUR' });
    const ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
    const esc = t => String(t).replace(/[&<>"']/g, m => ESC[m]);
    let ultimoFoco = null;

    const pintar = (c) => {
      pintarBolsa(c.item_count);
      if (!c.item_count) {
        cuerpo.innerHTML = '<div class="cajon__vacio"><p>Your bag is empty.</p><a href="' + raiz + '#cartel" class="btn mt3">See the pieces</a></div>';
        pie.innerHTML = '';
        return;
      }
      const lineas = c.items.map((it, n) => {
        const props = Object.entries(it.properties || {}).filter(([k, v]) => v && k.charAt(0) !== '_').map(([k, v]) => {
          const val = /\/uploads\//.test(v) ? '<a href="' + esc(v) + '" target="_blank" rel="noopener">photo received ✓</a>' : esc(v);
          return '<div><dt>' + esc(k) + '</dt><dd>' + val + '</dd></div>';
        }).join('');
        const desc = (it.line_level_discount_allocations || []).filter(d => d.amount > 0)
          .map(d => '<p class="cajon__descuento">' + esc(d.discount_application.title) + ' · −' + eur(d.amount) + '</p>').join('');
        const antes = it.original_line_price > it.final_line_price ? '<s>' + eur(it.original_line_price) + '</s> ' : '';
        const foto = it.image ? '<img src="' + esc(it.image) + (it.image.includes('?') ? '&' : '?') + 'width=160" width="72" height="72" alt="" loading="lazy">' : '';
        const variante = it.variant_title && !/Default/.test(it.variant_title) ? '<p class="cajon__variante">' + esc(it.variant_title) + '</p>' : '';
        return '<li class="cajon__linea">' +
          '<a href="' + esc(it.url) + '" class="cajon__foto">' + foto + '</a>' +
          '<div class="cajon__que"><p class="cajon__nombre">' + esc(it.product_title) + '</p>' + variante +
          (props ? '<dl class="cajon__grabado">' + props + '</dl>' : '') + desc +
          '<div class="cajon__fila"><span class="cajon__cantidad">' +
          '<button type="button" data-cajon-cant="' + (n + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="One less">−</button>' +
          '<span>' + it.quantity + '</span>' +
          '<button type="button" data-cajon-cant="' + (n + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="One more">+</button></span>' +
          '<span class="cajon__precio">' + antes + eur(it.final_line_price) + '</span></div></div></li>';
      }).join('');
      // sugerencias: piezas que aún no están en la bolsa
      const dentro = new Set(c.items.map(i => i.handle));
      const otras = piezas.filter(p => !dentro.has(p.handle)).slice(0, 3);
      const sugerencias = otras.length ? '<div class="cajon__sugerencias"><p class="cajon__oferta">' + esc(textos.oferta || '') + '</p><ul>' +
        otras.map(p => '<li><a href="' + esc(p.url) + '"><img src="' + esc(p.foto) + '" width="64" height="64" alt="" loading="lazy"><span>' + esc(p.titulo) + '<small>' + eur(p.precio) + '</small></span></a></li>').join('') +
        '</ul></div>' : '';
      cuerpo.innerHTML = '<ul class="cajon__lineas">' + lineas + '</ul>' + sugerencias;
      const ahorro = c.original_total_price - c.total_price;
      pie.innerHTML =
        (ahorro > 0 ? '<p class="cajon__suma"><span>Discount</span><span>−' + eur(ahorro) + '</span></p>' : '') +
        '<p class="cajon__suma cajon__total"><span>Total</span><span>' + eur(c.total_price) + '</span></p>' +
        '<p class="cajon__nota">Shipping is calculated at checkout. Free over €39 in Spain.</p>' +
        '<a href="' + raiz + 'checkout" class="btn btn--sello btn--grande btn--ancho">Checkout</a>' +
        '<a href="' + raiz + 'cart" class="cajon__ver">View the full bag</a>';
    };

    const traer = async () => (await fetch(raiz + 'cart.js', { headers: { Accept: 'application/json' } })).json();

    const abrir = async (c) => {
      ultimoFoco = document.activeElement;
      caja.hidden = false;
      document.documentElement.classList.add('cajon-abierto');
      setTimeout(() => { caja.dataset.abierto = 'true'; }, 20);
      if (!c) { cuerpo.innerHTML = '<p class="cajon__cargando">…</p>'; pie.innerHTML = ''; c = await traer(); }
      pintar(c);
      const x = $('.cajon__cerrar', caja); if (x) x.focus();
    };
    const cerrar = () => {
      caja.dataset.abierto = 'false';
      document.documentElement.classList.remove('cajon-abierto');
      setTimeout(() => { caja.hidden = true; }, 260);
      if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
    };

    caja.addEventListener('click', async (ev) => {
      if (ev.target.closest('[data-cajon-cerrar]')) { cerrar(); return; }
      const b = ev.target.closest('[data-cajon-cant]');
      if (b) {
        b.disabled = true;
        const r = await fetch(raiz + 'cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(b.dataset.cajonCant), quantity: Math.max(0, Number(b.dataset.q)) }),
        });
        pintar(await r.json());
      }
    });
    document.addEventListener('keydown', ev => { if (ev.key === 'Escape' && !caja.hidden) cerrar(); });
    $$('[data-cajon-abrir]').forEach(a => a.addEventListener('click', ev => { ev.preventDefault(); abrir(); }));

    window.maCajon = { abrir, cerrar };
  }

  function carrito() {
    const forma = $('[data-compra]');
    if (forma && datosProducto()) { carritoShopify(forma); return; }
    // En Shopify el contador lo pinta el servidor: nunca usar la bolsa de demostración local
    if (window.Shopify && window.Shopify.shop) return;

    const bolsa = JSON.parse(localStorage.getItem('ln_bolsa') || '[]');
    const pintar = () => {
      const n = bolsa.reduce((a, l) => a + l.cant, 0);
      $$('[data-bolsa]').forEach(e => {
        e.textContent = String(n);
        e.dataset.lleno = n > 0 ? 'true' : 'false';
      });
    };
    $$('[data-anadir]').forEach(b => {
      b.addEventListener('click', (ev) => {
        ev.preventDefault();
        if (b.hasAttribute('disabled')) return;
        bolsa.push({ ref: b.dataset.ref || 'pieza', cant: 1 });
        try { localStorage.setItem('ln_bolsa', JSON.stringify(bolsa)); } catch (e) { /* modo privado */ }
        pintar();
        const aviso = $('[data-aviso-bolsa]');
        if (aviso) {
          aviso.hidden = false;
          clearTimeout(aviso._t);
          aviso._t = setTimeout(() => (aviso.hidden = true), 4200);
        }
      });
    });
    pintar();
  }


  /* --- 11. Los packs ------------------------------------------------------
     Tres entradas: una, dos o tres piezas. La segunda al −30 %; con tres, segunda y tercera al −35 %.
     El precio sale de data-pvp, así que nunca se descuadra con el producto. */

  function packs() {
    const zona = $('[data-packs]');
    if (!zona) return;
    const forma = $('[data-compra]');
    const base = Number((forma && forma.dataset.pvp) || 0);
    if (!base) return;

    const eur = n => n.toLocaleString('en-IE', { style: 'currency', currency: 'EUR' });

    const calcular = () => {
      const precio = Number((forma && forma.dataset.pvp) || 0);
      $$('[data-pack]', zona).forEach(p => {
        const n = Number(p.dataset.pack);
        // la primera a precio entero, las demás con el descuento del pack, pieza a pieza como en el pago
        const total = precioPack(precio, n);
        const sinPack = precio * n;
        const ahorro = sinPack - total;

        const pon = (sel, txt) => { const e = $(sel, p); if (e) e.textContent = txt; };
        pon('[data-pack-total]', eur(total));
        pon('[data-pack-unidad]', eur(total / n) + ' each');
        if (ahorro > 0) {
          pon('[data-pack-antes]', eur(sinPack));
          pon('[data-pack-ahorro]', 'You save ' + eur(ahorro));
        }
      });
    };
    calcular();
    document.addEventListener('ma:precio', calcular);

    const pintar = () => {
      $$('[data-pack]', zona).forEach(p => {
        const r = $('input[type="radio"]', p);
        p.dataset.elegido = String(!!(r && r.checked));
      });
    };
    zona.addEventListener('change', pintar);
    pintar();
  }

  /* --- 12. Cuándo llega de verdad -----------------------------------------
     Se calcula desde hoy en días naturales, puerta a puerta (fabricación y
     envío incluidos), con los plazos reales a España de cada pieza. Si ya no
     llega antes del 24, se dice, en vez de dejar que el cliente lo descubra. */

  function entrega() {
    const zona = $('[data-entrega]');
    if (!zona) return;

    const mas = (desde, dias) => {
      const d = new Date(desde);
      d.setDate(d.getDate() + dias);
      return d;
    };
    const fmt = f => f.toLocaleDateString('en-GB', { day: 'numeric', month: 'long' });

    const hoy = new Date();
    const min = Number(zona.dataset.entregaMin || 7);
    const max = Number(zona.dataset.entregaMax || 12);

    const prueba = mas(hoy, 2);
    const pronto = mas(hoy, min);
    const tarde  = mas(hoy, max);

    // puede haber varios sitios con el mismo dato: se rellenan todos
    const pon = (sel, txt) => $$(sel, zona).forEach(e => (e.textContent = txt));
    pon('[data-entrega-hoy]', hoy.toLocaleDateString('en-GB', { day: 'numeric', month: 'long' }));
    pon('[data-entrega-prueba]', fmt(prueba));
    pon('[data-entrega-rango]', fmt(pronto) + ' – ' + fmt(tarde));

    const aviso = $('[data-entrega-navidad]', zona);
    if (aviso) {
      const nochebuena = new Date(hoy.getFullYear(), 11, 24);
      // la fecha de corte ya lleva el margen de Navidad: manda ella
      const llegaATiempo = tarde <= nochebuena && hoy <= CORTE;
      aviso.dataset.llega = String(llegaATiempo);
      aviso.textContent = llegaATiempo
        ? 'Arrives in time for Christmas Eve.'
        : 'No longer arrives before Christmas Eve: it would go into the January batch.';
    }
  }


  /* --- 13. Carrusel -------------------------------------------------------
     Flechas que se desactivan en los extremos. Si el contenido cabe entero,
     las flechas no aparecen: no hay nada que pasar.                        */

  function carruseles() {
    $$('[data-carrusel]').forEach(c => {
      const pista = $('[data-carrusel-pista]', c);
      const izq = $('[data-carrusel="izq"]', c) || $('[data-ir="izq"]', c);
      const der = $('[data-carrusel="der"]', c) || $('[data-ir="der"]', c);
      if (!pista) return;

      // Posición de cada tarjeta dentro de la pista
      const sitio = (h) =>
        h.getBoundingClientRect().left - pista.getBoundingClientRect().left + pista.scrollLeft;

      // El desplazamiento suave lo animamos nosotros: con scroll-snap activo,
      // scrollTo({behavior:'smooth'}) no mueve el carrusel en Chrome.
      let animacion = 0;
      const deslizar = (hasta) => {
        cancelAnimationFrame(animacion);
        // Sin movimiento reducido y con la pestaña a la vista, se anima.
        // Si la pestaña está oculta no hay fotogramas: se salta directo.
        if (quieto || document.hidden) { pista.scrollLeft = hasta; return; }
        const desde = pista.scrollLeft;
        const recorrido = hasta - desde;
        if (Math.abs(recorrido) < 2) return;
        const arranque = performance.now();
        const dura = Math.min(620, 260 + Math.abs(recorrido) * 0.45);
        const paso = (ahora) => {
          const t = Math.min(1, (ahora - arranque) / dura);
          const e = 1 - Math.pow(1 - t, 3);          // salida exponencial
          pista.scrollLeft = desde + recorrido * e;
          if (t < 1) animacion = requestAnimationFrame(paso);
        };
        animacion = requestAnimationFrame(paso);
      };

      // Saltar a la tarjeta siguiente o anterior. Por distancia no vale:
      // el scroll-snap devuelve el carrusel a la tarjeta de la que salió.
      const irA = (dir) => {
        const hijos = Array.from(pista.children);
        const x = pista.scrollLeft;
        const destino = dir > 0
          ? hijos.find(h => sitio(h) > x + 6)
          : hijos.slice().reverse().find(h => sitio(h) < x - 6);
        const tope = pista.scrollWidth - pista.clientWidth;
        deslizar(Math.max(0, Math.min(tope, destino ? sitio(destino) : (dir > 0 ? tope : 0))));
      };

      // Las flechas se apagan en los extremos. Si cabe todo, no hay flechas.
      const refrescar = () => {
        const sobra = pista.scrollWidth - pista.clientWidth;
        const flechas = $('[data-carrusel-flechas]', c);
        if (flechas) flechas.hidden = sobra < 8;
        if (izq) izq.disabled = pista.scrollLeft <= 2;
        if (der) der.disabled = pista.scrollLeft >= sobra - 2;
      };

      if (izq) izq.addEventListener('click', () => irA(-1));
      if (der) der.addEventListener('click', () => irA(1));
      pista.addEventListener('scroll', () => requestAnimationFrame(refrescar), { passive: true });
      addEventListener('resize', refrescar, { passive: true });
      refrescar();
    });
  }

  /* --- 14. La forma elegida, con su dibujo -------------------------------- */

  function formas() {
    const zona = $('[data-formas]');
    if (!zona) return;
    const ops = $$('.forma-op', zona);
    const pintar = () => ops.forEach(o => {
      const r = $('input', o);
      o.dataset.elegida = String(!!(r && r.checked));
    });
    zona.addEventListener('change', pintar);
    pintar();
  }

  /* --- 15. Arranque -------------------------------------------------------- */

  /* --- 16. Páginas legales de Shopify ----------------------------------------
     Las políticas llegan como un bloque de texto. Se les da la maqueta de las
     legales estáticas: el primer párrafo sube a la cabecera y el índice lateral
     se construye con los titulares. */

  function politica() {
    const cuerpo = $('.shopify-policy__body');
    if (!cuerpo) return;
    const intro = $('[data-ma-politica-intro]');
    const primero = $('.rte > p:first-child', cuerpo) || $('p', cuerpo);
    if (intro && primero && primero.textContent.trim().length > 20) {
      intro.innerHTML = primero.innerHTML;
      intro.hidden = false;
      primero.remove();
    }
    const indice = $('[data-ma-indice]');
    const titulares = $$('h2', cuerpo);
    if (indice && titulares.length > 1) {
      const ol = $('ol', indice);
      titulares.forEach((h, i) => {
        if (!h.id) h.id = 's' + (i + 1);
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.trim();
        li.appendChild(a);
        ol.appendChild(li);
      });
      indice.hidden = false;
    }
  }

  /* --- 17. Opción que se elige escribiendo ----------------------------------------
     En el collar, el número de corazones (y el precio) sale de las iniciales que se
     escriben; en el anillo, la variante ES la letra. La opción está oculta: el cliente
     solo escribe, y lo que se compra coincide siempre con lo que se graba. */

  function sincronizar() {
    const forma = $('[data-compra]');
    if (!forma) return;
    const grupo = $('[data-sincronizada]', forma);
    const campo = $('[data-sincroniza-modo]', forma);
    if (!grupo || !campo) return;
    const radios = $$('input[type="radio"]', grupo);

    const pintar = () => {
      const letras = campo.value.toUpperCase().replace(/[^A-Z]/g, '');
      let elegida = null;
      if (campo.dataset.sincronizaModo === 'cuenta') {
        const n = Math.max(1, letras.length);
        elegida = radios.find(r => parseInt(r.value, 10) === n);
      } else if (letras) {
        elegida = radios.find(r => r.value.toUpperCase() === letras.charAt(0));
      }
      if (elegida && !elegida.checked) {
        elegida.checked = true;
        forma.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };
    campo.addEventListener('input', pintar);
    pintar();
  }

  function alFinal() {
    $$('[data-talon], [data-talon-producto], [data-aviso-bolsa]').forEach(e => {
      if (e.parentElement !== document.body) document.body.appendChild(e);
    });
  }

  const arrancar = () => {
    alFinal(); politica(); fechas(); cuenta(); alzas(); rasgado(); galeria(); resumen();
    subidaFoto(); formaMaqueta(); packs(); entrega(); carruseles(); formas(); cajon();
    personalizador(); sincronizar(); variantes(); talonProducto(); carrito();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
